export const dashboardCardDefinitions = [];

export const getCardDefinitionById = (id) => {
  return dashboardCardDefinitions.find(card => card.id === id);
};
